module.exports = __webpack_public_path__ + "img/dod_day12_image_06.717b1bd9.jpg";